import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, Subject } from 'rxjs';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { RegistrationService } from '../registration.service';

@Component({
  selector: 'app-atlas-checkout-success',
  templateUrl: './atlas-checkout-success.component.html',
  styleUrls: ['./atlas-checkout-success.component.css'],
  standalone: false,
})
export class AtlasCheckoutSuccessComponent implements OnInit, OnDestroy {
  public returnToSubscriptionUrl = '/atlas/subscribe';
  public tenantId: string | null = null;
  public returnUrl: string | null = null;
  public atlasUrl = '';
  public portalUrl = '';
  public statusLabel = 'Provisioning';
  public statusMessage = 'Payment received. We are provisioning your Atlas environment now.';
  public ready = false;
  public provisioningFailed = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly registrationService: RegistrationService,
  ) {}

  ngOnInit(): void {
    this.tenantId = this.route.snapshot.queryParamMap.get('tenantId');
    const envLabel = environment.env || 'development';
    this.atlasUrl = `https://atlas.${envLabel}.datastor.io`;
    this.portalUrl = `https://portal.${envLabel}.datastor.io`;
    if (this.tenantId) {
      this.returnToSubscriptionUrl = `/atlas/subscribe?${new URLSearchParams({ tenantId: this.tenantId }).toString()}`;
    } else {
      this.returnUrl = document.referrer || null;
    }

    if (this.tenantId) {
      interval(5000)
        .pipe(
          startWith(0),
          switchMap(() => this.registrationService.getOnboardingStatus(this.tenantId!)),
          takeUntil(this.destroy$),
        )
        .subscribe({
          next: (response) => {
            if (response.atlas_portal_url) {
              this.atlasUrl = response.atlas_portal_url;
            }
            this.provisioningFailed = response.provisioning_failed;
            if (response.atlas_ready) {
              this.ready = true;
              this.provisioningFailed = false;
              this.statusLabel = 'Ready';
              this.statusMessage = 'Atlas is ready. You will also receive an email with your access link.';
            } else if (response.provisioning_failed) {
              this.ready = false;
              this.statusLabel = 'Attention needed';
              this.statusMessage = 'Payment was received, but Atlas provisioning did not complete successfully. Support follow-up is required.';
            } else {
              this.ready = false;
              this.statusLabel = 'Provisioning';
              this.statusMessage = 'Payment received. We are provisioning your Atlas environment now. We will email you when it is ready.';
            }
          },
          error: () => {
            this.statusLabel = 'Provisioning';
            this.statusMessage = 'Payment received. Provisioning is still in progress. We will email you when Atlas is ready.';
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
